// extracted by mini-css-extract-plugin
export default {"image":"Rooms_image__2UHjZ"};